import {AppLoader} from "shared/UI/UIKit/Loader";
import {AppFlex} from "shared/UI/UIKit/Flex";

export const Loader = () => {
  return (
    <AppFlex>
      <AppLoader/>
    </AppFlex>
  );
};